import clsx from "clsx";
import React, { useRef, useState } from "react";
import YouTube, { YouTubeProps } from "react-youtube";
import Icon from "../../../Foundation/Icon/Icon";
import ImageResponsive from "../../Image/ImageResponsive";
import { ImageFit } from "../../Image/interface/ImageData";
import {
  _LandingVideoHeaderContainer,
  _LandingVideoRoot,
} from "./LandingVideo.styled";
import FlexBox from "../../FlexBox/FlexBox";
import HighlightedTypography from "../../HighlightedTypography/HighlightedTypography";
import Typography from "../../../Foundation/Typography/Typography";
import htmlParse from "html-react-parser";

export interface ILandingVideoProps {
  videoId: string;
  poster: {
    desktop: string;
    mobile: string;
  };
  aspectRatio?: number;
  style?: React.CSSProperties;
  highlightedTitle?: string;
  title?: string;
  description?: string;
  className?: string;
  onShowPlayerChange?: (show: boolean) => void;
}

const LandingVideo = (props: ILandingVideoProps) => {
  const {
    videoId,
    poster,
    aspectRatio = 21 / 9,
    style,
    highlightedTitle,
    title,
    description,
    className,
    onShowPlayerChange,
  } = props;
  const playerRef = useRef<YouTube>(null);
  const [showPlayer, setShowPlayer] = useState(false);

  const setShowPlayerAndNotify = (show: boolean) => {
    setShowPlayer(show);
    if (onShowPlayerChange) {
      onShowPlayerChange(show);
    }
  };

  const opts: YouTubeProps["opts"] = {
    height: "100%",
    width: "100%",
    rel: "0",
  };

  const handlePlay = () => {
    setShowPlayerAndNotify(true);
    setTimeout(() => {
      playerRef.current?.internalPlayer?.playVideo();
    }, 1000);
  };

  return (
    <div className={className}>
      {title && (
        <FlexBox direction="column" align="center">
          <_LandingVideoHeaderContainer
            direction="column"
            align="center"
            className="landing-pacman__header"
          >
            <HighlightedTypography
              variant="h4"
              align="center"
              highlightedText={highlightedTitle || ""}
              className="landing-pacman__title"
            >
              {title || ""}
            </HighlightedTypography>
            <Typography
              variant="body"
              align="center"
              className="landing-pacman__description"
            >
              {htmlParse(description + "")}
            </Typography>
          </_LandingVideoHeaderContainer>
        </FlexBox>
      )}
      <_LandingVideoRoot $aspectRatio={aspectRatio} style={style} className={clsx("landing-video-container")}>
        <ImageResponsive
          alt=""
          desktop={{
            image: {
              id: poster.desktop,
              fit: ImageFit.COVER,
              quality: 80,
              aspectRatio: aspectRatio,
            },
            imgStyle: {
              overflow: "hidden",
              aspectRatio: aspectRatio,
              width: "100%",
            },
          }}
          mobile={{
            image: {
              id: poster.mobile,
              fit: ImageFit.COVER,
              quality: 100,
              aspectRatio: 1,
              outputPixelDensities: [1, 2],
            },
            imgStyle: {
              overflow: "hidden",
              aspectRatio: 1,
              width: "100%",
            },
          }}
        />
        <div className="landing-video-play" onClick={handlePlay}>
          <Icon icon="play" size={64} viewBox="0 0 64 64" />
        </div>
        <YouTube
          ref={playerRef}
          videoId={videoId}
          opts={opts}
          className={clsx("landing-video-yt", { show: showPlayer })}
          onPause={() => setShowPlayerAndNotify(false)}
        />
      </_LandingVideoRoot>
    </div>
  );
};

export default LandingVideo;
